import { EventEmitter, Injectable } from '@angular/core';
import { BlocklyToolboxCategory, BlockyJson } from './../components/blockly/blockly-editor/blocky-types.types';


export interface BlockSearchEntry {
  type: string;
  json: BlockyJson;
  custom?: string;
  tooltip?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BlockSearchService {
  public query: string = "";
  public resultCount = 0;
  public readonly resultEvent = new EventEmitter<BlocklyToolboxCategory>();
  public readonly cancleEvent = new EventEmitter<void>();

  private blocks: BlockSearchEntry[] = [];
  /**
   * Sucht alle Blöcke im aktuellen Workspace, deren Typ, Text oder Tooltip den Suchbegriff enthält.
   * @param query Suchbegriff
   * @returns Array der gefundenen Blöcke
   */
  public searchBlocks(query: string): BlocklyToolboxCategory {
    this.query = query;
    if (query == "") {
      this.resultCount = 0;
      return { kind: 'category' };
    }
    const lowerQuery = query.toLowerCase();
    const results = this.blocks.filter(entry =>
      entry.type.toLowerCase().includes(lowerQuery) ||
      entry.json.message0.toLowerCase().includes(lowerQuery) ||
      (entry.tooltip ?? '').toLowerCase().includes(lowerQuery)
    );


    this.resultCount = results.length;

    const r: BlocklyToolboxCategory = { kind: 'category', 'name': results.length + ' Treffer', contents: results.map(e => ({ 'kind': 'block', type: e.type })) };
    this.resultEvent.emit(r);
    return r;


  }

  public register(entry: BlockSearchEntry) {
    const idx = this.blocks.findIndex(b => b.type === entry.type);
    if (idx >= 0) {
      this.blocks[idx] = entry;
    } else {
      this.blocks.push(entry);
    }
  }

  /** Alle bisher registrierten Blöcke (z.B. für die Blockly-Docs-Extraktion). */
  public getAllBlocks(): BlockSearchEntry[] {
    return this.blocks;
  }
  public cancle() {
    // TODO: The 'emit' function requires a mandatory boolean argument
    this.cancleEvent.emit();
  }

}
